import ReportIcon from '@mui/icons-material/Report';

export default function NoAccess() {
  //#region UI
  return (
    <div className="min-h-screen flex justify-center bg-gray-100">
      <div className="p-28 text-center">
        <img alt="Noaccess" src="/no-access.png" className="w-full mx-auto" />
        <h1 className="text-4xl font-bold text-theme-color mb-4">Access Denied</h1>
        <div className='flex flex-col lg:flex-row gap-2 items-center lg:items-start'>
          <ReportIcon className='text-red-500' fontSize='large'/>
          <p className="text-gray-700 text-lg mb-6">You do not have permission to view this page.</p>
        </div>
      </div>
    </div>
  );
  //#endregion
}